import { Stomp } from "@stomp/stompjs";
import React from "react";
import SockJS from "sockjs-client";
import { keycloak } from "../components/auth";
import { getVariable } from "../services/api";
import { getUserSession } from "../services/user-service";

const CONHECIGAME_API = "CONHECIGAME_API";
const stompClient = Stomp.client();

export function useWebsocket() {
  const endpoint = `/handler/?access_token=${keycloak.token}`;

  const errorCallback = React.useCallback((error) => {
    console.log(error.headers.message);
  }, []);

  const connectWebsocket = React.useCallback(
    async (connectCallback) => {
      getVariable(CONHECIGAME_API).then((url) => {
        stompClient.webSocketFactory = () => {
          return new SockJS(url + endpoint);
        };

        getUserSession().then((res) => {
          const headers = {
            Authorization: "Bearer " + keycloak.token,
            userId: res.data.id,
          };

          if (!stompClient.active) {
            stompClient.connect(headers, connectCallback, errorCallback);
          }
        });
      });
    },
    [endpoint, errorCallback]
  );

  return { stompClient, connectWebsocket };
}
